const getClipboardData = (rootState) => rootState.ws.clipboard.data;

export default getClipboardData;
